'use strict';

import BaseService from './base.service';

class BrandsService extends BaseService {
  /* @ngInject */
  constructor(Brand, SegaUser) {
    super(Brand, SegaUser);
    Object.assign(this, {
      Brand
    });
  }
}

export default BrandsService;
